// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".messageThread__messageThread___3lXpC{display:flex;flex-direction:column;justify-content:space-between;flex-grow:1;min-height:200px}.messageThread__chatMessages___2mNGU{overflow-y:auto;padding:20px}.messageThread__chatEndedDivider___HcY1-{display:flex;align-items:center;color:#717070;font-size:12px;margin:20px 0}.messageThread__chatEndedLabel___2cEDo{margin:0 15px}.messageThread__chatEndedLine___2S6et{height:1px;flex-grow:1;background-color:#e9eff5}.messageThread__createConversationContainer___3n48n{display:flex;background-color:#fff;padding:20px;border-top-left-radius:12px;border-top-right-radius:12px;justify-content:center;box-shadow:0 -1px 6px 0 rgba(201,201,201,.3)}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"messageThread": "messageThread__messageThread___3lXpC",
	"chatMessages": "messageThread__chatMessages___2mNGU",
	"chatEndedDivider": "messageThread__chatEndedDivider___HcY1-",
	"chatEndedLabel": "messageThread__chatEndedLabel___2cEDo",
	"chatEndedLine": "messageThread__chatEndedLine___2S6et",
	"createConversationContainer": "messageThread__createConversationContainer___3n48n"
};
module.exports = exports;
